import rm from "./rm/zh-CN";

const t = {}

t.loading = 'Loading...'

t.brand = {}
t.brand.lg = 'BMW JOY Learning Platform'
t.brand.mini = 'RC'

t.add = 'Add'
t.delete = 'Delete'
t.deleteBatch = 'Delete'
t.update = 'Edit'
t.view = 'Check'
t.reset = 'Reset'
t.query = 'Query'
t.export = 'Export'
t.handle = 'Action'
t.confirm = 'Confirm'
t.cancel = 'Cancel'
t.logout = 'Sign Out'
t.tmpStorage = 'Memory'
t.remove = 'remove'
t.checkAll = 'Check all'
t.dealWith = 'Handle'

t.prompt = {}
t.prompt.title = 'Prompt'
t.prompt.info = 'Confirm to carry out [{handle}] operation?'
t.prompt.success = 'Succeeded'
t.prompt.failed = 'Failed'
t.prompt.deleteBatch = 'Please select delete item'

t.validate = {}
t.validate.required = 'Required field cannot be empty'
t.validate.format = '{attr} format error'
t.validate.isPassword = 'Passwords consist of only 8-30 bits of English letters, numbers and underscores.'
t.validate.isNumOrEn = 'Please enter an English letter or number'
t.validate.validateLength = 'Enter up to {handle} characters'
t.validate.validateMobile = 'Malformed phone number'
t.validate.validateTelphone = 'Please enter the correct fixed line (format: area code + number, such as 010-1234567)'
t.validate.validatePhoneTwo = 'Please enter the correct phone number or landline number (format: area code + number, such as 0411-1234567)'
t.validate.validateZipCode = 'Please enter the correct zip code'
t.validate.isSpecialCharacters = 'The input cannot contain special characters'
t.validate.validateEMail = 'Please input the correct email address'
t.validate.agreement = 'Please agree to the user agreement first'

t.upload = {}
t.upload.text = 'Drop files here, or <em>Click Upload</em>'
t.upload.tip = 'Only support {format} format files! '
t.upload.button = 'Click to upload'

t.datePicker = {}
t.datePicker.range = 'To'
t.datePicker.start = 'Start Date'
t.datePicker.end = 'End Date'

t.fullscreen = {}
t.fullscreen.prompt = 'Your browser does not support this operation'

t.updatePassword = {}
t.updatePassword.title = 'Change Password'
t.updatePassword.username = 'Account'
t.updatePassword.password = 'Original'
t.updatePassword.newPassword = 'New Password'
t.updatePassword.comfirmPassword = 'Confirm'
t.updatePassword.validate = {}
t.updatePassword.validate.comfirmPassword = 'Confirm password is not consistent with new password input'

t.contentTabs = {}
t.contentTabs.closeCurrent = 'Close Current Tab'
t.contentTabs.closeOther = 'Close Other Tabs'
t.contentTabs.closeAll = 'Close All Tabs'

/* pages */
t.notFound = {}
t.notFound.desc = 'Sorry! <em>missing</em> on the page you visited...'
t.notFound.back = 'Previous Page'
t.notFound.home = 'Home'

t.login = {}
t.login.title = 'Sign In'
t.login.username = 'UserName'
t.login.password = 'Password'
t.login.captcha = 'Verification Code'
t.login.demo = 'Demo'
t.login.copyright = 'Dhc FrameWork'

t.home = {}
t.home.desc = {}
t.home.desc.title = 'Project Introduction'
t.home.desc.list = [
  'bmw cloud is a micro service platform based on Spring cloud, providing enterprises with one-stop micro service solutions',
  'Based on the latest development of Spring Cloud finchley.sr2, Spring Cloud Gateway, Spring Boot 2.0, Mybatis, Element 2.0+',
  'The code style is elegant and simple, easy to understand, and meets the specification requirements of "alibaba Java development manual", which can be used as enterprise code specification',
  'Excellent menu function permissions, the front end can flexibly control the display of pages and buttons, and the back end can intercept unauthorized requests',
  'Good data access management, just add corresponding annotations without any other code, can achieve data filtering, data access purposes',
  'Flexible role permission management. When adding a role, the role permission can only be a subset of the creator permission, which can effectively prevent the permission from exceeding the authority',
  'Flexible log management, can view log, operation log, exception log, easy to audit and BUG location',
  'The flexible internationalization configuration supports simplified Chinese, traditional Chinese and English. If you need to add a new language, you only need to add a new language [i18n] file',
  'Flexible front-end dynamic routing, new pages do not need to modify the routing file, can also dynamically add TAB tags in the page'
]

/* modules */
t.model = {}
t.model.name = 'Name'
t.model.key = 'Information'
t.model.version = 'Version'
t.model.createTime = 'Create Time'
t.model.lastUpdateTime = 'Update Time'
t.model.design = 'Online Design'
t.model.deploy = 'Deployment'
t.model.description = 'Description'

t.process = {}
t.process.name = 'Name'
t.process.key = 'Identification'
t.process.deployFile = 'Deploy Process File'
t.process.id = 'Process ID'
t.process.deploymentId = 'Deployment ID'
t.process.version = 'Version'
t.process.resourceName = 'XML'
t.process.diagramResourceName = 'Image'
t.process.deploymentTime = 'Deployment Time'
t.process.active = 'Activate'
t.process.suspend = 'Hang'
t.process.convertToModel = 'Convert to model'

t.running = {}
t.running.id = 'Instance ID'
t.running.definitionKey = 'Define Key'
t.running.processDefinitionId = 'Define ID'
t.running.processDefinitionName = 'Define The Name'
t.running.activityId = 'Current Link'
t.running.suspended = 'Whether Hang'
t.running.suspended0 = 'No'
t.running.suspended1 = 'Yes'

t.news = {}
t.news.title = 'Title'
t.news.pubDate = 'Publish Time'
t.news.createDate = 'Create Time'
t.news.content = 'Content'

t.schedule = {}
t.schedule.beanName = 'Bean Name'
t.schedule.beanNameTips = 'Spring bean name, eg: testTask'
t.schedule.pauseBatch = 'Pause'
t.schedule.resumeBatch = 'Recovery'
t.schedule.runBatch = 'Execution'
t.schedule.log = 'Log List'
t.schedule.params = 'Parameters'
t.schedule.cronExpression = 'Cron Expression'
t.schedule.cronExpressionTips = 'Example: 0 0 12 * * ?'
t.schedule.remark = 'Remarks'
t.schedule.status = 'Status'
t.schedule.status0 = 'Pause'
t.schedule.status1 = 'Normal'
t.schedule.statusLog0 = 'Failed'
t.schedule.statusLog1 = 'Success'
t.schedule.pause = 'Pause'
t.schedule.resume = 'Restore'
t.schedule.run = 'Execute'
t.schedule.jobId = 'Task ID'
t.schedule.times = 'Time-consuming (unit: milliseconds)'
t.schedule.createDate = 'Execution Time'

t.mail = {}
t.mail.name = 'Name'
t.mail.config = 'Mail Configuration'
t.mail.subject = 'Theme'
t.mail.createDate = 'Create Time'
t.mail.send = 'Send Mail'
t.mail.content = 'Content'
t.mail.smtp = 'SMTP'
t.mail.port = 'Port Number'
t.mail.username = 'Email Account'
t.mail.password = 'Mailbox Password'
t.mail.mailTo = 'Recipient'
t.mail.mailCc = 'Cc'
t.mail.params = 'Template Parameter'
t.mail.paramsTips = 'Example: {"code": "123456"}'
t.mail.templateId = 'Template ID'
t.mail.status = 'Status'
t.mail.status0 = 'Send Failed'
t.mail.status1 = 'Successfully Sent'
t.mail.mailFrom = 'Sender'
t.mail.createDate = 'Send Time'

t.sms = {}
t.sms.mobile = 'Mobile Number'
t.sms.status = 'Status'
t.sms.status0 = 'Send Failed'
t.sms.status1 = 'Successfully Sent'
t.sms.config = 'SMS Configuration'
t.sms.send = 'Send SMS'
t.sms.platform = 'platform Type'
t.sms.platform1 = 'Alibaba Cloud'
t.sms.platform2 = 'Tencent Cloud'
t.sms.params = 'Parameters'
t.sms.paramsTips = 'eg: {"code": "123456"}'
t.sms.params1 = 'Parameter 1'
t.sms.params2 = 'Parameter 2'
t.sms.params3 = 'Parameter 3'
t.sms.params4 = 'Parameter 4'
t.sms.createDate = 'Send Time'
t.sms.aliyunAccessKeyId = 'Key'
t.sms.aliyunAccessKeyIdTips = 'Alibaba Cloud AccessKeyId'
t.sms.aliyunAccessKeySecret = 'Secret'
t.sms.aliyunAccessKeySecretTips = 'Alibaba Cloud AccessKeySecret'
t.sms.aliyunSignName = 'SMS Signature'
t.sms.aliyunTemplateCode = 'SMS Template'
t.sms.aliyunTemplateCodeTips = 'SMS Template CODE'
t.sms.qcloudAppId = 'AppId'
t.sms.qcloudAppIdTips = 'Tencent Cloud AppId'
t.sms.qcloudAppKey = 'AppKey'
t.sms.qcloudAppKeyTips = 'Tencent Cloud AppKey'
t.sms.qcloudSignName = 'SMS Signature'
t.sms.qcloudTemplateId = 'SMS Template'
t.sms.qcloudTemplateIdTips = 'SMS template ID'

t.oss = {}
t.oss.config = 'Cloud Storage Configuration'
t.oss.upload = 'Upload File'
t.oss.url = 'URL Address'
t.oss.createDate = 'Create Time'
t.oss.type = 'Type'
t.oss.type1 = 'Seven Cows'
t.oss.type2 = 'Alibaba Cloud'
t.oss.type3 = 'Tencent Cloud'
t.oss.type4 = 'FastDFS'
t.oss.type5 = 'Local Upload'
t.oss.qiniuDomain = 'Domain Name'
t.oss.qiniuDomainTips = 'Seven cattle bound domain name'
t.oss.qiniuPrefix = 'Path Prefix'
t.oss.qiniuPrefixTips = 'Do not set default to empty'
t.oss.qiniuAccessKey = 'AccessKey'
t.oss.qiniuAccessKeyTips = 'Seven cattle AccessKey'
t.oss.qiniuSecretKey = 'SecretKey'
t.oss.qiniuSecretKeyTips = 'Seven Cow SecretKey'
t.oss.qiniuBucketName = 'Space Name'
t.oss.qiniuBucketNameTips = 'Seven cattle storage space name'
t.oss.aliyunDomain = 'Domain Name'
t.oss.aliyunDomainTips = 'Alibaba Cloud bound domain name'
t.oss.aliyunPrefix = 'Path Prefix'
t.oss.aliyunPrefixTips = 'Do not set default to empty'
t.oss.aliyunEndPoint = 'EndPoint'
t.oss.aliyunEndPointTips = 'Ali Cloud EndPoint'
t.oss.aliyunAccessKeyId = 'AccessKeyId'
t.oss.aliyunAccessKeyIdTips = 'Alibaba Cloud AccessKeyId'
t.oss.aliyunAccessKeySecret = 'AccessKeySecret'
t.oss.aliyunAccessKeySecretTips = 'Alibaba Cloud AccessKeySecret'
t.oss.aliyunBucketName = 'BucketName'
t.oss.aliyunBucketNameTips = 'Alibaba Cloud BucketName'
t.oss.qcloudDomain = 'Domain Name'
t.oss.qcloudDomainTips = 'Tencent cloud bound domain name'
t.oss.qcloudPrefix = 'Path Prefix'
t.oss.qcloudPrefixTips = 'Do not set default to empty'
t.oss.qcloudAppId = 'AppId'
t.oss.qcloudAppIdTips = 'Tencent Cloud AppId'
t.oss.qcloudSecretId = 'SecretId'
t.oss.qcloudSecretIdTips = 'Tencent Cloud SecretD'
t.oss.qcloudSecretKey = 'SecretKey'
t.oss.qcloudSecretKeyTips = 'Tencent Cloud SecretKey'
t.oss.qcloudBucketName = 'BucketName'
t.oss.qcloudBucketNameTips = 'Tencent Cloud BucketName'
t.oss.qcloudRegion = 'Affiliate'
t.oss.qcloudRegionTips = 'Please Select'
t.oss.qcloudRegionBeijing1 = 'Beijing District 1 (North China)'
t.oss.qcloudRegionBeijing = 'Beijing'
t.oss.qcloudRegionShanghai = 'Shanghai (East China)'
t.oss.qcloudRegionGuangzhou = 'Guangzhou (South China)'
t.oss.qcloudRegionChengdu = 'Chengdu (Southwest)'
t.oss.qcloudRegionChongqing = 'Chongqing'
t.oss.qcloudRegionSingapore = 'Singapore'
t.oss.qcloudRegionHongkong = 'HongKong'
t.oss.qcloudRegionToronto = 'Toronto'
t.oss.qcloudRegionFrankfurt = 'Frankfurt'
t.oss.localDomain = 'Domain Name'
t.oss.localDomainTips = 'Binded domain name'
t.oss.fastdfsDomain = 'Domain Name'
t.oss.fastdfsDomainTips = 'Binded domain name'
t.oss.localPrefix = 'Path Prefix'
t.oss.localPrefixTips = 'Do not set default to empty'
t.oss.localPath = 'Storage Directory'
t.oss.localPathTips = 'eg: D:/upload'

t.dept = {}
t.dept.name = 'Name'
t.dept.parentName = 'Superior'
t.dept.sort = 'Sort'
t.dept.parentNameDefault = 'Top Department'

t.dict = {}
t.dict.dictName = 'Name'
t.dict.dictNameCn = 'ChineseName'
t.dict.dictNameEn = 'EnglishName'
t.dict.dictType = 'Type'
t.dict.dictValue = 'Value'
t.dict.sort = 'Sort'
t.dict.remark = 'Remarks'
t.dict.createTime = 'Create Date'
t.dict.dictValue = 'Dict Value'
t.dict.status = 'Status'

t.logError = {}
t.logError.module = 'Module Name'
t.logError.requestUri = 'Request URI'
t.logError.requestMethod = 'Request Method'
t.logError.requestParams = 'Request Parameters'
t.logError.ip = 'IP'
t.logError.userAgent = 'User Agent'
t.logError.createDate = 'Create Date'
t.logError.errorInfo = 'Exception'

t.logLogin = {}
t.logLogin.creatorName = 'Username'
t.logLogin.status = 'Status'
t.logLogin.status0 = 'Failed'
t.logLogin.status1 = 'Success'
t.logLogin.status2 = 'Locked'
t.logLogin.operation = 'User Action'
t.logLogin.operation0 = 'Login'
t.logLogin.operation1 = 'Exit'
t.logLogin.ip = 'IP'
t.logLogin.userAgent = 'User-Agent'
t.logLogin.createDate = 'Create Date'

t.logOperation = {}
t.logOperation.module = 'Module Name'
t.logOperation.status = 'Status'
t.logOperation.status0 = 'Failed'
t.logOperation.status1 = 'Success'
t.logOperation.creatorName = 'Username'
t.logOperation.operation = 'User Action'
t.logOperation.requestUri = 'Request URI'
t.logOperation.requestMethod = 'Request Mode'
t.logOperation.requestParams = 'Request Parameters'
t.logOperation.requestTime = 'Request Duration'
t.logOperation.ip = 'IP'
t.logOperation.userAgent = 'User-Agent'
t.logOperation.createDate = 'Create Date'

t.menu = {}
t.menu.sysCode = 'Subsystem'
t.menu.name = 'Name'
t.menu.icon = 'Icon'
t.menu.type = 'Type'
t.menu.type0 = 'Table'
t.menu.type1 = 'Menu'
t.menu.type2 = 'Button'
t.menu.sort = 'Sort'
t.menu.url = 'Route'
t.menu.permissions = 'Auth ID'
t.menu.permissionsTips = 'eg: sys:menu:save'
t.menu.parentName = 'Superior'
t.menu.parentNameDefault = 'Top Menu'
t.menu.resource = 'Auth Resources'
t.menu.resourceUrl = 'Resource URL'
t.menu.resourceMethod = 'Request Method'
t.menu.resourceAddItem = 'Add an Item'
t.menu.writesysCode = 'Enter the subsystem'
t.menu.hide = 'Whether to display'
t.menu.orderNum = 'Sort'

t.params = {}
t.params.paramCode = 'Code'
t.params.paramValue = 'Value'
t.params.remark = 'Remarks'

t.role = {}
t.role.name = 'Name'
t.role.remark = 'Remarks'
t.role.createUser = 'Create User'
t.role.createDate = 'Create Date'
t.role.menuList = 'Menu Scope'
t.role.deptList = 'Data Scope'
t.role.companyDistributor = 'Data Scope'
t.role.distributionUser = 'Assign users'

t.user = {}
t.user.username = 'Username'
t.user.deptName = 'Department'
t.user.email = 'Email'
t.user.mobile = 'Mobile'
t.user.status = 'Status'
t.user.status0 = 'Disable'
t.user.status1 = 'Enable'
t.user.createDate = 'Create Date'
t.user.password = 'Password'
t.user.comfirmPassword = 'Confirm'
t.user.realName = 'Real Name'
t.user.gender = 'Gender'
t.user.gender0 = 'Male'
t.user.gender1 = 'Female'
t.user.gender2 = 'Secure'
t.user.roleIdList = 'Role Config'
t.user.validate = {}
t.user.validate.comfirmPassword = 'Confirm password is not consistent with password input'
t.user.customerType = 'User Type'
t.user.grouping = 'Grouping'
t.user.role = 'System Role'
t.user.position = 'Primary Position'
t.user.userName = 'UserName'
t.user.userEmail = 'Email'
t.user.companyDistributor = 'Company Name'
t.user.incumbency = 'Status'
t.user.brand = 'Brand'
t.user.dotType = 'Outlet Type'
t.user.leaveDate = 'Departure Date of Company'
t.user.accessionDate = 'Start Date of Joining Current Company'
t.user.citywhere = 'City'
t.user.phonenumber = 'Phone Number'
t.user.query = 'Query'
t.user.accountMerging = 'Account Consolidation'
t.user.newlyBuild = 'New'
t.user.export = 'Export'
t.user.batchImport = 'Batch Import'
t.user.operation = 'Operating'
t.user.onTheJob = 'In-Service'
t.user.absenceFromDuty = 'In-Service'
t.user.currentversion = 'Current Version'
t.user.essentialInformation = 'Basic Information'
t.user.inputContent = 'Please enter the content'
t.user.chineseName = 'Chinese Name'
t.user.idcard = 'ID Card'
t.user.dateofbirth = 'Date of Birth'
t.user.userID = 'User ID'
t.user.education = 'Education'
t.user.accessionDate2 = 'Join The Network Date'
t.user.buildmen = 'Founder'
t.user.lastlogintime = 'Last Login Time'
t.user.setting = 'Setting'
t.user.accountinformation = 'Account Information'
t.user.permissionclassification = 'Permission Type'
t.user.status10 = 'Login Allowed'
t.user.firstname = 'Last Name(Pinyin)'
t.user.lastname = 'First Name(Pinyin)'
t.user.name = 'Name'
t.user.passportIdcard = 'ID Number'
t.user.reset = 'Reset'
t.user.more = 'Expand Show More'
t.user.hide = 'Hide'
t.user.move = 'Activity'
t.user.unmove = 'Inactive'
t.user.input = 'Please Enter'
t.user.select = 'Please Choose'
t.user.business = 'Business Information'
t.user.BMWtime = 'BMW Age'
t.user.GWMinformation = 'BMW Group Information'
t.user.GWMcompany = 'Company'
t.user.department = 'Department'
t.user.partner = 'Partner Information'
t.user.dealer = 'Dealer Information'
t.user.brandCodes = 'Brand'
t.user.bbaNo = ' BBA No'
t.user.nscno = 'NSC No'
t.user.outlet = 'Dealer Name'
t.user.joinjobdate = 'Start Date of Primary Job'
t.user.leavejobdate = 'Departure Date of Primary Job'
t.user.parttimejob1 = 'Secondary Job 1'
t.user.joinparttimejob1 = 'Start Date of Secondary Job 1'
t.user.leaveparttimejob1 = 'Departure Date of Secondary Job 1'
t.user.parttimejob2 = 'Secondary Job 2'
t.user.joinparttimejob2 = 'Start Date of Secondary Job 2'
t.user.leaveparttimejob2 = 'Departure Date of Secondary Job 2'
t.user.parttimejob3 = 'Secondary Job 3'
t.user.joinparttimejob3 = 'Start Date of Secondary Job 3'
t.user.leaveparttimejob3 = 'Departure Date of Secondary Job 3'
t.user.parttimejob4 = 'Secondary Job 4'
t.user.joinparttimejob4 = 'Start Date of Secondary Job 4'
t.user.leaveparttimejob4 = 'Departure Date of Secondary Job 4'
t.user.chiefpostManager = 'Superivsor of Secondary Job'
t.user.beststudent = 'BEST Student Information'
t.user.joinschool = 'Start Date of BEST'
t.user.leaveschool = 'Departure Date of BEST'
t.user.major = 'Major'
t.user.graduation = 'Status'
t.user.trainer = 'Trainer Information'
t.user.trainerrole = 'Trainer Information'
t.user.trainerall = 'Trainer Category'
t.user.trainerteam = 'Trainer Team Category'
t.user.enddateftrialtalk = 'End Date Of Trial Teach'
t.user.effectivedate = 'Effective Date'
t.user.trainingobjectives = 'Annual Training Target'
t.user.TAlevl = 'TA级别'
t.user.teacherlvel = 'Trainer Level'
t.user.save = 'Save'
t.user.back = 'Return'
t.user.agreeconceal = 'Agree to Collect Privacy'
t.user.Trainingschool = 'Affiliated Training School'
t.user.reservedDistributor = 'Dealer intended to sign-off'
t.user.joininDistributor = 'Agree to join the Talent Pool'
t.user.numberbankaccount = 'BEST Candidate Account'
t.user.trainerrole = 'Trainer Role'
t.user.contractnumber = 'Contract No.'
t.user.leavejoinschooldate = 'Entry time must not exceed the departure time'
t.user.verificationfirstname = 'Fore name cannot be empty'
t.user.verificationlastname = 'Family name cannot be empty'
t.user.verificationemail = 'Mailbox must not be empty'
t.user.verificationtelphone = 'Phone number cannot be empty'
t.user.verificationidcard = 'Please enter the correct ID card'
t.user.checkdate = 'Select Date'
t.user.history = 'Historic Version'
t.user.thirtydays = 'Join the company within 30 days before and after'
t.user.onebyone = 'Not allowed beyond January 1 of the current year'
t.user.telephone = 'Phone number cannot be empty'
t.user.telephoneerro = 'Please enter a valid phone number'
t.user.verificationemailerrow = 'Please enter your vaild email'
t.user.verificationidcarderrow = 'Please enter the correct ID number'
t.user.verificationlength = 'Between 1 and 20 characters in length'
t.user.verificationparttime = 'Part-time can not be repeated'
t.user.generateAccount = 'Generate Account'
t.user.downloadtemplate = 'Download Template / Batch Import'
t.user.batchdeletion = 'Batch Deletion'
t.user.userpost = 'Post'
t.user.userImporttemplate = 'User import template'
t.user.sure = 'Determine Right'
t.user.verificationagreePolicy = 'Please choose whether you agree to collect privacy'
t.user.idtype = 'ID Type'
t.user.chiefpostManager = 'Superivsor of Secondary Job'
t.user.chiefpostManager1 = 'Superivsor of Secondary Job 1'
t.user.chiefpostManager2 = 'Superivsor of Secondary Job 2'
t.user.chiefpostManager3 = 'Superivsor of Secondary Job 3'
t.user.chiefpostManager4 = 'Superivsor of Secondary Job 4'
t.user.jobyear = 'Current Work Age'
t.user.joblevl = 'Job'
t.user.parttimejobaddnum = 'Up to 4 part-time jobs'
t.user.parttimejobcutnum = 'Minimum 1 part-time job'
t.user.verificationfirstname1 = 'Cannot contain spaces'
t.user.deletparttimejob = 'Determine to delete part-time jobs?'
t.user.add = 'add'
t.user.delete = 'delete'
t.user.popTitle = 'Please select the column to display'
t.user.userExport = 'User_Export'
t.user.transfer = 'transfer'
t.user.leaveOffice = 'leave'
t.user.positionNow = 'current position'
t.user.transferposition = 'transfer position'
t.user.transferpositiondate = 'transfer position'
t.user.transferparttimejob1 = 'transfer position 1'
t.user.transferparttimejob2 = 'transfer position 2'
t.user.transferparttimejob3 = 'transfer position 3'
t.user.transferparttimejob4 = 'transfer position 4'
t.user.transferparttimejobtime1 = 'transfer position date 1'
t.user.transferparttimejobtime2 = 'transfer position date 2'
t.user.transferparttimejobtime3 = 'transfer position date 3'
t.user.transferparttimejobtime4 = 'transfer position date 4'
t.user.leaveWhy = ' reason for leave'
t.user.Distributor = 'Recommend Talents'
t.user.presentation = 'Warm Tip: The choice is to light up the star for the employee and let more HR pay attention to him or her.'
t.running.suspended0 = 'no'
t.running.suspended1 = 'yes'
t.user.checkadmin = 'check admin'
t.user.orgTypeCode = 'distributor Code'
t.user.outletType = 'outlet type'
t.user.noticeFaceCheck = '请管理员提醒用户在收到注册成功通知的当日，须登录悦学苑APP端并完成身份及面部识别验证'

t.organization = {}
t.organization.orgType = 'Org.Type'
t.organization.status = 'Status'
t.organization.abbreviation = 'Abbr.(EN)'
t.organization.name = 'Name(EN)'
t.organization.abbreviationZh = 'Chinese Abbreviation'
t.organization.abbreviationEn = 'English Abbreviation'
t.organization.nameZh = 'Chinese Full Name'
t.organization.nameEn = 'English Full Name'
t.organization.nameZhAndNameEn = 'Chinese Name/English Name'
t.organization.address = 'Address'
t.organization.zipCode = 'Zip Code'
t.organization.mobile = 'Mobile'
t.organization.contacter = 'Contact Person'
t.organization.contacterMobile = 'Contact Phone'
t.organization.fax = 'Fax'
t.organization.joinDateBmw = 'Start Date of Joining BMW Group'
t.organization.orgCode = 'Orgnization Number'
t.organization.comType = 'Company Type'
t.organization.brandCode = 'Brand'
t.organization.networkType = 'Outlet Type'
t.organization.parentDealerGroupId = 'Dealer Groupup'
t.organization.cityIds = 'City'
t.organization.openDate = 'Opening Date'
t.organization.openDateStart = 'Starting From Opening Time'
t.organization.openDateEnd = 'Opening Time'
t.organization.nscNo = 'NSC No'
t.organization.bbaNo = 'BBA No'
t.organization.nscCbuNo = 'NSC No'
t.organization.bbaCkdNo = 'BBA No'
t.organization.brand = 'Brand'
t.organization.preNscNo = 'Pre NSC No'
t.organization.preBbaNo = 'Pre BBA No'
t.organization.preRegisterNameZh = 'Pre-registration of Chinese names'
t.organization.preRegisterNameEn = 'Pre-registration of English names'
t.organization.mainNetworkFlag = 'Main Outlet(Y/N)'
t.organization.motherShopId = 'Parent Store'
t.organization.groupCode = 'Group Number'
t.organization.keyword = 'Please Enter Keywords'
t.organization.contractList = 'List Of Contracts'
t.organization.contractCode = 'Contract Number'
t.organization.startDate = 'Start Date'
t.organization.endDate = 'End Date'
t.organization.teacherLevel = 'Teacher Grade'
t.organization.serviceProject = 'Service Items'
t.organization.projectType = 'Project Type'
t.organization.cityLevel = 'City Level'
t.organization.price = 'Price'
t.organization.addRow = 'Add a new line'
t.organization.dealerSize = 'Dealer Size'
t.organization.tagName = 'Label'
t.organization.save = 'Save'
t.organization.back = 'Back'
t.organization.venderNo = ' Vender Code'
t.organization.dealerShipStatus = 'Status'
t.organization.brandCodes = 'Brand'
t.organization.dmsCode = 'DMS Code'
t.organization.dealerShipType = 'Dealer Type'
t.organization.parentDealeId = 'Dealer Name'
t.organization.networkStatus = 'Status'
t.organization.mainNetworkId = 'Associated with major outlets'
t.organization.salesPartnerId = 'Sales Partner ID'
t.organization.startData = 'Starting Time'
t.organization.endData = 'End Time'
t.organization.orgCodeMessage = 'Automatic Generated'
t.organization.officeMail = 'Email'
t.organization.dealerNumber = 'Number Of Dealer'
t.organization.outletNumber = 'Number Of Outlets'
t.organization.nscNoOwn = 'Own NSC No'
t.organization.brandCodesOwn = 'Own Brand'
t.organization.company = 'Company'
t.organization.companyMessage = 'Chinese And English Abbreviation /NSC NO./BBA NO.'

t.organization.basicInformation = 'Essential Information'
t.organization.orgType10 = 'BMW Group'
t.organization.orgType2030 = 'Partners/Collaborative Institutions'
t.organization.orgType40 = 'Dealer Group'
t.organization.orgType50 = 'DealerShip'
t.organization.orgType60 = 'Outlet'
t.organization.organizationExport = 'Orgnization_Export'

// position数据
t.position = {}
t.position.positionCode = 'Job Code'
t.position.positionName = 'Job Name'
t.position.positionNameCn = 'Job Name(CN)'
t.position.positionNameEn = 'Job Name(EN)'
t.position.brandCode = 'JC Brand'
t.position.singlePosition = 'Single Position in Outlet'
t.position.partTimeJobFlag = 'Part-time Job Allowed'
t.position.orgType = 'Organization Type'
t.position.positionType = 'JC Category'
t.position.positionGroupType = ' JC Team Category'
t.position.produceFlag = 'Productive Position'
t.position.customerFlag = 'Customer Facing Staff'
t.position.certificationIds = 'Cert Category'
t.position.keyPositionCode = 'Key Function Code'
t.position.status = 'Status'
t.position.allowPartJobs = 'Allow Part Jobs'
t.position.keyPositionFlag = 'Key Position Flag'
t.position.candidateFlag = 'Candidate Flag'
t.position.taApprovalFlag = 'TaApproval Flag'
t.position.positionDesc = 'Position Desc'
t.position.positionDescCn = 'Position Desc Cn'
t.position.positionDescEn = 'Position Desc En'
t.position.completeResumeFlag = 'Complete Resume Flag'
t.position.transferConfirm ='Are you sure to transfer position？'

// 门户login
t.protaLogin = {}
t.protaLogin.loginBtn = 'Login'
t.protaLogin.registerBtn = 'Register'
t.protaLogin.accountLogin = 'Account Login'
t.protaLogin.phoneLogin = 'Phone Login'
t.protaLogin.username = 'UserName'
t.protaLogin.password = 'Password'
t.protaLogin.captcha = 'Captcha'
t.protaLogin.findPassword = 'Forget the Password'
t.protaLogin.agree = 'Agree'
t.protaLogin.nameLabel = 'Name'
t.protaLogin.captchaLabel = 'Captcha'
t.protaLogin.passwordLabel = 'Password'
t.protaLogin.phoneLabel = 'Mobile'
t.protaLogin.getCaptcha = 'Get Captcha'
t.protaLogin.getCaptchaTip = 'Retrieve in seconds'
t.protaLogin.mobileVerified = 'Please enter your cell phone number.'
t.protaLogin.captchaVerified = 'Please enter your captcha'
t.protaLogin.modifyPassword = 'Modify password'
t.protaLogin.continue = 'continue'

// header的登录
t.headerLogin = {}
t.headerLogin.login = 'Login'
t.headerLogin.logout = 'Logout'

// header的菜单
t.headerMenu = {}
t.headerMenu.main = 'Home'
t.headerMenu.information = 'Info'
t.headerMenu.addBEST = 'Join BEST'
t.headerMenu.academicHorizon = 'College Horizon'
t.headerMenu.addBMW = 'Join BMW'
t.headerMenu.manage = 'Manage'
t.headerMenu.login = 'Login'
t.headerMenu.register = 'Register'
t.headerMenu.xiaobao = 'xiaobao'

t.common = {}
t.common.tagName = 'Business Type'
t.common.tagChecked = 'Label Setting'
t.common.openMore = 'Expand More'
t.common.hide = 'Collapse'

// label数据
t.label = {}
t.label.labelName = 'Label Name'
t.label.labelFlag = 'Label Flag'
t.label.masterData = 'Business Type'
t.label.showFlag = 'Whether To Display'

// 忘记密码
t.protaForgetPassword = {}
t.protaForgetPassword.title = 'Forget the Password'
t.protaForgetPassword.phoneLabel = 'Mobile'
t.protaForgetPassword.phonePlace = 'Mobile'
t.protaForgetPassword.captchaLabel = 'Captcha'
t.protaForgetPassword.captchaPlace = 'Captcha'
t.protaForgetPassword.captchaBtn = 'Captcha'
t.protaForgetPassword.passwordLabel = 'Password'
t.protaForgetPassword.passwordPlace = '8-30 bit length'
t.protaForgetPassword.passwordSureLabel = 'Confirm'
t.protaForgetPassword.passwordSurePlace = 'Confirm Password'
t.protaForgetPassword.sureBtn = 'complete'
t.protaForgetPassword.passwordTip = '8-30 bit length，Only letters and numbers can be entered'
t.protaForgetPassword.mobileOrEmail = 'Please enter your mobile phone number or verification number'
t.protaForgetPassword.mailTODO = 'Email password retrieval is under development……'
t.protaForgetPassword.oldPassword = 'old password'

// footer
t.footer = {}
t.footer.copyright = '©️ BMW AG 2019'
t.footer.schoolMailTxt = 'College Mailbox:'
t.footer.schoolMail = 'bmw@bmw.com'
t.footer.contactUsTxt = 'Contact us:'
t.footer.contactUs = 'No. 2, Dongbinhe Road, Fengtai District, Beijing'
t.footer.linkTxt = 'Quick Links:'
t.footer.link = 'BMW official website'

// person
t.protaPerson = {}
t.protaPerson.todo = 'Todo'
t.protaPerson.enrollApprove = 'Registration Approval'
t.protaPerson.knowledgeApprove = 'Knowledge Approval'
t.protaPerson.JobApprove = 'Job Correction'
t.protaPerson.paperApprove = 'Paper Correction'
t.protaPerson.enrollExam = 'Enrollment Examination'
t.protaPerson.courseStudy = 'Course Learning'
t.protaPerson.task = 'Task'
t.protaPerson.medal = 'Medal'
t.protaPerson.other = 'Other'
t.protaPerson.trainingRecord = 'Training Records'
t.protaPerson.findDetail = 'See Details'
t.protaPerson.growthPath = 'Growth Path'

// 门户注册
t.protaRegister = {}
t.protaRegister.title = 'Visitor Registration'
t.protaRegister.nameLabel = 'User Name'
t.protaRegister.namePlace = 'Enter One User Name'
t.protaRegister.nameCnLabel = 'Full Name'
t.protaRegister.nameCnPlace = 'Please enter your name.'
t.protaRegister.mailLabel = 'Mailbox'
t.protaRegister.mailPlace = 'Email Address'
t.protaRegister.phoneLabel = 'Mobile'
t.protaRegister.phonePlace = ' Phone Number.'
t.protaRegister.captchaLabel = 'Captcha'
t.protaRegister.captchaPlace = 'Captcha'
t.protaRegister.captchaBtn = 'Captcha'
t.protaRegister.passwordLabel = 'Password'
t.protaRegister.passwordPlace = '8-30 bit length'
t.protaRegister.passwordSureLabel = 'Confirm'
t.protaRegister.passwordSurePlace = 'Confirm Password'
t.protaRegister.agree = 'Agree'
t.protaRegister.agreement = 'User Registration Protocol'
t.protaRegister.registerBtn = 'Register'

// region数据
t.region = {}
t.region.regionCode = 'Region Code：'
t.region.parentName = 'Parent Name：'
t.region.regionName = 'Region Name：'
t.region.regionGrade = 'Region Grade：'
t.region.remark = 'Remark:'
t.region.save = 'Save'

// 工作流
t.workflow = {}
t.workflow.workflowId = 'Association Number'
t.workflow.previousWorkflowId = 'Process name'
t.workflow.workflowName = 'Task Name'
t.workflow.workflowType = 'type'

t.activiti = {}
t.activiti.missionName = 'missionName'
t.activiti.processName = 'processName'
t.activiti.sponsor = 'sponsor'
t.activiti.startingTime = 'startingTime'
t.activiti.timeOfArrival = 'timeOfArrival'
t.activiti.processInitiationTime = 'processInitiationTime'
t.activiti.taskArrivalTime = 'taskArrivalTime'
t.activiti.approval = 'approval'
t.activiti.initiated = 'initiated'
t.activiti.currentTaskNode = 'currentTaskNode'
t.activiti.currentNodeApprover = 'currentNodeApprover'
t.activiti.taskRetentionTime = 'taskRetentionTime'
t.activiti.handleTime = 'handleTime'
t.activiti.taskInformation = 'taskInformation'
t.activiti.approver = 'approver'
t.activiti.taskApprovalTime = 'taskApprovalTime'
t.activiti.businessInformation = 'businessInformation'
t.activiti.approvalHistory = 'approvalHistory'
t.activiti.approvalStatus = 'approvalStatus'
t.activiti.approvalComments = 'approvalComments'
t.activiti.processingTime = 'processingTime'
t.activiti.details = 'details'
t.activiti.viewFlowChart = 'viewFlowChart'
t.activiti.agree = 'agree'
t.activiti.disagree = 'disagree'
t.activiti.pleaseEnterApprovalOpinion = 'pleaseEnterApprovalOpinion'
t.activiti.submit = 'submit'
t.activiti.withdraw = 'withdraw'

t.res = {}
// Course Classroom Rela
// Course Classroom Rela
t.res.courseclassroomrela = {}
t.res.courseclassroomrela.courseNumber = 'Course'
t.res.courseclassroomrela.teamClassification = 'Category of course teams'
t.res.courseclassroomrela.addRela = 'Add'
t.res.courseclassroomrela.download = 'Download Template'
t.res.courseclassroomrela.import = 'Relationship import template'
t.res.courseclassroomrela.export = 'Relationship_Export'
t.res.courseclassroomrela.batchDeletion = 'Batch Deletion'
t.res.courseclassroomrela.courseNoPlaceholder = 'Code/Name'
t.res.courseclassroomrela.courseClassId = 'Course Category'
t.res.courseclassroomrela.coursesSatus = 'Course Status'
t.res.courseclassroomrela.classroomNo = 'Room Code'
t.res.courseclassroomrela.classroomName = 'Room Name'
t.res.courseclassroomrela.classroomClass = 'Room Category'
t.res.courseclassroomrela.classStatus = 'Room Status'
t.res.courseclassroomrela.city = 'City'
t.res.courseclassroomrela.classification = 'Site'
t.res.courseclassroomrela.classroomCount = 'Number of Room in need'
t.res.courseclassroomrela.selectFromLeft = 'Please Select'
t.res.courseclassroomrela.courseId = 'Course ID'
t.res.courseclassroomrela.courseNo = 'Code'
t.res.courseclassroomrela.courseName = 'Name'
t.res.courseclassroomrela.courseTime = 'Days'
t.res.courseclassroomrela.maxPersonNo = 'Maximum number'
t.res.courseclassroomrela.miniPersonNo = 'Minimum number'
t.res.courseclassroomrela.bySystem = 'Automatic calculated'
t.res.courseclassroomrela.classroompoolExplain1 = '说明：1.教室池是指本课程上课时可供选择的所有备选教室。'
t.res.courseclassroomrela.classroompoolExplain2 = '2.课程所需教室数量等于教室池数量。'
t.res.courseclassroomrela.classroompoolExplain3 = '3.排课时，每个教室池仅选择一个教室使用。'
t.res.courseclassroomrela.classroompool = 'Room Pool'
t.res.courseclassroomrela.remark = 'Remark'
t.res.courseclassroomrela.label = 'No.'
t.res.courseclassroomrela.classroomNo = 'Room Code'
t.res.courseclassroomrela.roomCnName = 'Room Name'
t.res.courseclassroomrela.classroomClass = 'Category'
t.res.courseclassroomrela.siteName = 'Site'
t.res.courseclassroomrela.status = 'Status'
t.res.courseclassroomrela.courseclassroomrelaExcel = 'CourseRoomRelationship'
t.res.courseclassroomrela.courseclassroomrelaExcelTemple = 'CourseRoomRelationship_Template'
t.res.courseclassroomrela.classroomLabel = 'Room label'
t.res.courseclassroomrela.priority = 'Priority'
t.res.courseclassroomrela.poolName = 'Room Pool'
t.res.courseclassroomrela.save = 'Save'
t.res.courseclassroomrela.close = 'Close'
t.res.courseclassroomrela.determine = 'Confirm'
t.res.courseclassroomrela.remove = 'Remove'
t.res.courseclassroomrela.addreturn = 'Return'
t.res.courseclassroomrela.serialNo = 'No'
t.res.courseclassroomrela.annual = 'Year'
t.res.courseclassroomrela.reportAnnualTarget = 'Annual Target'
t.res.courseclassroomrela.roomArea = 'Area'
t.res.courseclassroomrela.maxNo = 'Number'
t.res.courseclassroomrela.floor = 'Floor'
t.res.courseclassroomrela.liftNo = 'Number of lifts'
t.res.courseclassroomrela.workplaceNo = 'Number of stations'
t.res.courseclassroomrela.priorityCheck = 'Please enter the priority'
t.res.courseclassroomrela.selected = 'Selected Room'
t.res.courseclassroomrela.selectPriority = 'Please enter the priority'
t.res.courseclassroomrela.selectCheck = 'Please select the room'
t.res.courseclassroomrela.courseTeamClassification = 'Category of course teams'
t.res.courseclassroomrela.classroomTag = 'Room label'
t.res.courseclassroomrela.alternativeClassroom = 'Select Room'
t.res.courseclassroomrela.ondb = '该教室已选择，请选择其他教室!'
t.res.courseclassroomrela.classroom = 'Room'
t.res.courseclassroomrela.alternativeCourse = 'Select Course'
t.res.courseclassroomrela.cannotDelete = 'Room Pool 1 must be a classroom'
t.res.courseclassroomrela.course = 'Please select course'
t.res.courseclassroomrela.classroompoolSelect = 'Please select a classroom'
t.res.courseclassroomrela.advancedSearch = 'advanced search'
t.res.courseclassroomrela.courseClassId1 = 'Course Category1'
t.res.courseclassroomrela.courseClassId2 = 'Course Category2'
t.res.courseclassroomrela.courseClassId3 = 'Course Category3'
t.res.courseclassroomrela.repeatQuery = "can't repeat"

// Course Trainer Rela
t.res.coursetrainerrela = {}
t.res.coursetrainerrela.teamClassification = 'Category of course teams'
t.res.coursetrainerrela.trainer = 'Trainer'
t.res.coursetrainerrela.trainerPlaceholder = 'User Name/Name'
t.res.coursetrainerrela.city = 'City'
t.res.coursetrainerrela.trainerfication = 'Category of trainer teams'
t.res.coursetrainerrela.addRela = 'Add'
t.res.coursetrainerrela.download = 'Download Template'
t.res.coursetrainerrela.import = 'Relationship import template'
t.res.coursetrainerrela.export = 'Relationship_Export'
t.res.coursetrainerrela.batchDeletion = 'Batch Deletion'
t.res.coursetrainerrela.trainerCount = 'Number of Trainer in need'
t.res.coursetrainerrela.trainerpoolExplain1 = '说明：1.培训师池是指本课程上课时可供选择的所有备选培训师。'
t.res.coursetrainerrela.trainerpoolExplain2 = '2.课程所需培训师数量等于培训师池数量。'
t.res.coursetrainerrela.trainerpoolExplain3 = '3.排课时，每个培训师池仅选择一个培训师使用。'
t.res.coursetrainerrela.trainerpool = 'Trainer Pool'
t.res.coursetrainerrela.trainerUserName = 'User Name'
t.res.coursetrainerrela.trainerEnName = 'Name'
t.res.coursetrainerrela.company = 'Company'
t.res.coursetrainerrela.trainerStatus = 'Status'
t.res.coursetrainerrela.trainerLabel = 'Trainer label'
t.res.coursetrainerrela.qualfication = 'Qualification'
t.res.coursetrainerrela.alternativeTrainer = 'Select Trainer'
t.res.coursetrainerrela.trainerpoolSelect = 'Please select a Trainer'
t.res.coursetrainerrela.coursetrainerrelaExcelTemple = 'CourseTrainerRelationship_Template'
t.res.coursetrainerrela.coursetrainerrelaExcel = 'CourseTrainerRelationship'
t.res.coursetrainerrela.cannotDelete = 'Trainer Pool 1 must have a classroom'
t.res.coursetrainerrela.corporation = 'Company'
t.res.coursetrainerrela.courseCount = '可授课数量'
t.res.coursetrainerrela.qualficationCheck = 'Please enter the qualification'
t.res.coursetrainerrela.selectQualfication = 'Please enter the qualification'
t.res.coursetrainerrela.trainerNo = 'Trainer Code'
t.res.coursetrainerrela.orgType = 'Organization Type'
t.res.coursetrainerrela.annual = 'Year'
t.res.coursetrainerrela.phonenumber = 'Phone Number'
t.res.coursetrainerrela.jobcodeJoinDate = 'Start Date of Primary Job'
t.res.coursetrainerrela.ondb = '该培训师已选择，请选择其他培训师!'
t.res.coursetrainerrela.downloadExcelError = '导入文件的错误数据'

t.res.edit = '编辑'
t.res.activity = '活动'
t.res.noActivity = '不活动'
t.res.getCheckTokenError = '获取access_token失败'
t.res.checkTokenErrorForZCHC = '校验access_token失败'

// 教室信息roomName
t.res.cri = {}
t.res.cri.createTrainRoom = '创建培训教室'
t.res.cri.tag = '标签'
t.res.cri.yearTargetList = '年度目标列表'

t.res.cri.ATTemplateExport = '年度目标模板'
t.res.cri.ATargetImport = '年度目标导入'
t.res.cri.classroomActivityStatus = '确定将教室状态改为“活动”？'
t.res.cri.classroomInactiveStatus = '确定将教室状态改为“不活动”？'
t.res.cri.serialNo = '序号'
t.res.cri.classroomNo = '教室编号'
t.res.cri.sysAutoCreate = '系统自动生成'
t.res.cri.roomName = '教室名称'
t.res.cri.roomCnName = '教室名称'
t.res.cri.inputRoomCnName = '请输入教室名称'
t.res.cri.roomCnAbbr = '教室简称'
t.res.cri.inputRoomCnAbbr = '请输入教室简称'
t.res.cri.subordinateSite = '所属场地'
t.res.cri.classroomClass = '教室分类'
t.res.cri.status = '教室状态'
t.res.cri.startTime = '开始时间'
t.res.cri.ifCount = '是否计算利用率'
t.res.cri.floor = '楼层'
t.res.cri.inputFloor = '请输入楼层'
t.res.cri.file = '是否有教室布局文件'
t.res.cri.classroominfo = '教室信息'
t.res.cri.exportAnnualTarget = '教室年度目标模板'
t.res.cri.download = '是否确定下载教室布局文件？'
t.res.cri.room = '请输入教室名称/简称'


t.res.cri.edit = '编辑'
t.res.cri.unInactive = '不活动'
t.res.cri.inactive = '活动'
t.res.cri.calendar = '日历'

t.res.cri.roomTag = '教室标签'

t.res.cri.save = '保存'
t.res.cri.endTime = '结束时间'
t.res.cri.inputEndTime = '请输入结束时间'
t.res.cri.rentalFee = '租用费用(元)'
t.res.cri.inputRentalFee = '请输入租用费用(元)'
t.res.cri.managementFee = '管理费用(元)'
t.res.cri.inputManagementFee = '请输入管理费用(元)'
t.res.cri.cateringExpenses = '餐饮费用(元)'
t.res.cri.inputCateringExpenses = '请输入餐饮费用(元)'
t.res.cri.ifCount = '是否计算利用率'
t.res.cri.roomArea = '面积'
t.res.cri.inputRoomArea = '请输入面积'
t.res.cri.floor = '楼层'
t.res.cri.liftNo = '举升机数量'
t.res.cri.inputLiftNo = '请输入举升机数量'
t.res.cri.workplaceNo = '工位数量'
t.res.cri.inputWorkplaceNo = '请输入工位数量'
t.res.cri.uploadLayoutFiles = '上传教室布局文件'
t.res.cri.maxNo = '最大人数'
t.res.cri.inputMaxNo = '请输入最大人数'

t.res.cri.operation = '操作'
t.res.cri.tagType = '标签类别'
t.res.cri.tagContent = '标签内容'
t.res.cri.year = '年份'
t.res.cri.yearTarget = '报表年度目标'

// 教室信息-> 表单校验
t.res.cri.r = {}
t.res.cri.r.roomCnName = '教室中文名称不能为空'
t.res.cri.r.roomCnAbbr = '教室中文简称不能为空'
t.res.cri.r.classroomClass = '教室分类不能为空'
t.res.cri.r.siteId = '所属场地不能为空'
t.res.cri.r.status = '教室分类不能为空'
t.res.cri.r.startTime = '开始时间不能为空'
t.res.cri.r.rentalFee = '租用费用不能为空'
t.res.cri.r.managementFee = '管理费用不能为空'
t.res.cri.r.cateringExpenses = '餐饮费用不能为空'
t.res.cri.r.ifCount = '是否统计不能为空'

t.res.cri.r.notNull = '不能为空'
t.res.cri.r.nonnegativeFloat = '请输入非负的数字'
t.res.cri.r.phoneCheck = '请输入正确的电话'
t.res.cri.r.nonnegativeInteger = '请输入非负的整数'
t.res.cri.r.number = '楼层请输入正整数'
t.res.cri.r.annual = '年度目标列表中，年份不能为空！'
t.res.cri.r.annualCheck = '年度目标列表中，只能输入当前及以后年份！'
t.res.cri.r.reportAnnualTarget = '年度目标列表中，年度目标值不能为空！'
t.res.cri.r.reportAnnualTargetCheck = '报表年度目标值必须为正整数！'
t.res.cri.r.reportAnnualCheck = '年份必须为正整数！'
t.res.cri.r.yearCheck = '年份已经存在！'
t.res.cri.r.upload = '上传教室布局文件'
t.res.cri.r.checkSiteInfoEndTime = '开始时间不能晚于结束时间！'

// 所属场地
t.res.cri.site = {}
t.res.cri.site.siteNo = '场地编号'
t.res.cri.site.siteCnName = '场地中文名称'
t.res.cri.site.siteCnAbbr = '场地中文简称'
t.res.cri.site.siteId = '所属公司'
t.res.cri.site.siteClassId = '场地分类'
t.res.cri.site.status = '状态'
t.res.cri.site.siteInfo = '场地信息'
t.res.cri.site.siteClass = '实体场地与虚拟场地不允许相互切换！'
t.res.cri.site.siteClassroomType = '所属场地类型必须与教室分类类型保持一致！'
t.res.cri.site.cityIdNull = '所在城市不能为空!'
t.res.cri.site.companyIdNull = '所属公司不能为空!'
t.res.cri.site.addressNull = '场地地址不能为空!'
t.res.cri.site.cateringExpenses = '餐饮费用请输入正确的数'

t.res.cri.site.pleaseChooseData = '请选择数据'

// 场地信息
t.res.site = {}
t.res.site.serialNumber = '序号'
t.res.site.name = '场地名称'
t.res.site.code = '场地编号'
t.res.site.siteActivityStatus = '确定将场地状态改为“活动”？'
t.res.site.siteInactiveStatus = '确定将场地状态改为“不活动”？'
t.res.site.shortName = '场地简称'
t.res.site.inputShortName = '请输入场地简称'
t.res.site.type = '所属分类'
t.res.site.selectType = '请先选择所属分类'
t.res.site.company = '所属公司'
t.res.site.city = '所在城市'
t.res.site.classification = '场地分类'
t.res.site.label = '场地标签'
t.res.site.status = '场地状态'
t.res.site.ChineseName = '场地名称'
t.res.site.inputChineseName = '请输入场地名称'
t.res.site.contacts = '联系人'
t.res.site.inputContacts = '请输入联系人'
t.res.site.telephone = '联系电话'
t.res.site.inputTelephone = '请输入联系电话'
t.res.site.address = '场地地址'
t.res.site.inputAddress = '请输入场地地址'
t.res.site.startTime = '开始时间'
t.res.site.endTime = '结束时间'
t.res.site.inputEndTime = '请输入结束时间'
t.res.site.cateringExpenses = '餐饮费用'
t.res.site.notNull = '不能为空'
t.res.site.selectSiteInfo = '选择场地'
t.res.site.createClassroom = '创建教室'
t.res.site.ondb = '该场地已选择，请选择其他场地!'
t.res.site.selected = '已选场地'

// 车辆信息管理
t.res.vehinfo = {}
t.res.vehinfo.serialNo = '序号'
t.res.vehinfo.chassisNo = '车辆底盘号'
t.res.vehinfo.inputChassisNo = '请输入17位车辆底盘号'
t.res.vehinfo.vehicleClassId = '车型分类'
t.res.vehinfo.label = '车辆标签'
t.res.vehinfo.vehicleClassification = '车辆分类'
t.res.vehinfo.companyId = '所属公司'
t.res.vehinfo.subordinateSiteId = '所属场地'
t.res.vehinfo.presentSiteId = '当前场地'
t.res.vehinfo.status = '车辆状态'
t.res.vehinfo.isUpload = '是否有配置信息'
t.res.vehinfo.upload = '上传车辆配置详细信息文件(上传格式为jpg/png/xlsx/xls/zip/rar/txt/pdf文件)'
t.res.vehinfo.upFile = '上传文件'
t.res.vehinfo.uploadTips = '只能上传一个文件'
t.res.vehinfo.edit = '编辑'
t.res.vehinfo.check = '查看'
t.res.vehinfo.yes = '是'
t.res.vehinfo.no = '否'
t.res.vehinfo.inactive = '活动'
t.res.vehinfo.unInactive = '不活动'
t.res.vehinfo.calendar = '日历'
t.res.vehinfo.replaceVeh = '替换车辆'
t.res.vehinfo.rdCodeId = '研发代码'
t.res.vehinfo.brandId = '品牌'
t.res.vehinfo.productionDate = '生产日期'
t.res.vehinfo.inputProductionDate = '请输入生产日期'
t.res.vehinfo.startTime = '开始时间'
t.res.vehinfo.endTime = '结束时间'
t.res.vehinfo.inputEndTime = '请输入结束时间'
t.res.vehinfo.endTime = '结束时间'
t.res.vehinfo.ifCount = '是否计算利用率'
t.res.vehinfo.engineModel = '发动机型号'
t.res.vehinfo.inputEngineModel = '请输入发动机型号'
t.res.vehinfo.remark = '备注'
t.res.vehinfo.inputRemark = '请输入备注'
t.res.vehinfo.ATTemplateExport = '车辆信息模板'
t.res.vehinfo.ATargetImport = '车辆信息导入'
t.res.vehinfo.save = '保存'
t.res.vehinfo.back = '返回'
t.res.vehinfo.replace = '车辆替换'
t.res.vehinfo.replaceCar = '被替换车辆'
t.res.vehinfo.replaceNewCar = '替换新车辆'
t.res.vehinfo.startDate = '开始时间'
t.res.vehinfo.endDate = '结束时间'
t.res.vehinfo.export = '车辆信息管理'
t.res.vehinfo.selected = '已选车辆'
t.res.vehinfo.exportAnnualTarget = '车辆信息年度目标模板'
t.res.vehinfo.ondb = '该车辆已选择，请选择其他车辆!'
t.res.vehinfo.vehicleActivityStatus = '确定将车辆状态改为“活动”？'
t.res.vehinfo.vehicleInactiveStatus = '确定将车辆状态改为“不活动”？'
t.res.vehinfo.select = '请选择'
t.res.vehinfo.input = '请输入'
t.res.vehinfo.download = '是否确定下载车辆配置文件'
t.res.vehinfo.exportError = '错误信息'

// 车型分类，教室分类
t.res.classroom = {}
t.res.classroom.unFold = '展开所有'
t.res.classroom.fold = '收起所有'
t.res.classroom.activity = '活动'
t.res.classroom.see = '显示'
t.res.classroom.baseInfo = '基本信息'
t.res.classroom.pName = '上级节点名称'
t.res.classroom.state = '分类状态'
t.res.classroom.name = '分类名称'
t.res.classroom.isSynchro = '是否同步'
t.res.classroom.synchro = '同步'
t.res.classroom.isBatchUpload = '是否允许批量上传'

// 课程车辆关系维护
t.res.rela = {}
t.res.rela.courseNumber = '课程代码'
t.res.rela.course = '课程'
t.res.rela.courseName = '课程中文名称'
t.res.rela.courseTeamClassification = '课程团队分类'
t.res.rela.teamClassification = '团队分类'
t.res.rela.vehiclesNumber = '课程所需车辆数量'
t.res.rela.workstation = '工位'
t.res.rela.priority = '优先级'
t.res.rela.status = '状态'
t.res.rela.operation = '操作'
t.res.rela.addRela = '新增'
t.res.rela.download = '模板下载'
t.res.rela.import = '导入'
t.res.rela.export = '导出'
t.res.rela.batchDeletion = '批量删除'
t.res.rela.courseState = '课程状态'
t.res.rela.coursevehiclerela = '课程与车辆关系'
t.res.rela.courseVehicleRelaTemple = '课程与车辆关系模板'

t.res.rela.courseDate = '课程时间'
t.res.rela.miniPersonNo = '最小人数'
t.res.rela.courseClass = '课程分类'
t.res.rela.Number = '课程所需车辆数量'
t.res.rela.determine = '确定'
t.res.rela.courseClass1 = '课程分类1'
t.res.rela.courseClass2 = '课程分类2'
t.res.rela.courseClass3 = '课程分类3'
t.res.rela.isUpload = '车辆配置信息'
t.res.rela.label = 'NO'
t.res.rela.altervehicles = '备选车辆'
t.res.rela.addreturn = '返回'
t.res.rela.insert = '新增'
t.res.rela.delete = '移除'
t.res.rela.alternativeCourse = '选择课程'
t.res.rela.alternativeVehicles = '选择备选车辆'
t.res.rela.priorityCheck = '优先级不能为空'
t.res.rela.selectCheck = '您未选中任何数据！'
t.res.rela.selectPriority = '请选择优先级！'
t.res.rela.selectCourseNo = '请选择课程编号！'
t.res.rela.selectDelete = '请选中需要删除的数据！'
t.res.rela.onOk = '所选车辆在该工位已存在，请重新勾选！'
t.res.rela.courseId = '请选择课程！'
t.res.rela.station = '请在工位中选择车辆！'
t.res.rela.select = '请点击"课程编号"选择'

// 经销商部门管理
t.res.department = {}
t.res.department.departmentName = '部门名称'
t.res.department.departmentCnName = '部门名称'
t.res.department.departmentEnName = '部门英文名称'
t.res.department.parentDepartmentName = '上级部门名称'
t.res.department.createDepartment = '新增'
t.res.department.code = '部门代码'
t.res.department.icon = '部门图标'
t.res.department.addJobs = '添加岗位'
t.res.department.jobName = '岗位名称'
t.res.department.jobCode = '岗位代码'
t.res.department.deleteDepartment =
    '删除该部门时将同时删除其下属部门，是否确认删除该部门？'
t.res.department.deleteDep = '是否确认删除该部门？'
t.res.department.deleteJob =
    '删除该岗位时将同时删除其下属岗位，是否确认删除该岗位？'
t.res.department.deletePosition = '是否确认删除该岗位？'

// 经销商组织架构模板管理
t.res.departmentTemple = {}
t.res.departmentTemple.keyword = '关键词'
t.res.departmentTemple.name = '模板名称'
t.res.departmentTemple.templeName = '模板名称'
t.res.departmentTemple.templeEnName = '模板英文名称'
t.res.departmentTemple.createTemple = '新增'
t.res.departmentTemple.scale = '经销商规模'
t.res.departmentTemple.delete = '删除'
t.res.departmentTemple.addOrg = '添加部门'
t.res.departmentTemple.addNextPost = '新增下级部门'
t.res.departmentTemple.addNextJob = '新增下级岗位'
t.res.departmentTemple.selectJob = '选择岗位'
t.res.departmentTemple.selectDepartment = '选择部门'
t.res.departmentTemple.job = '岗位'
t.res.departmentTemple.department = '部门'

// 经销商组织架构建议值维护
t.res.departmentValue = {}
t.res.departmentValue.upSearch = '高级搜索'
t.res.departmentValue.nameCode = '经销商名称/编号'
t.res.departmentValue.type = '网点类型'
t.res.departmentValue.shopType = '网点状态'
t.res.departmentValue.groupName = '集团名称'
t.res.departmentValue.city = '所在城市'
t.res.departmentValue.exportTemple = '导出模板'
t.res.departmentValue.importStandardValue = '导入参考值'
t.res.departmentValue.shopName = '经销商名称'
t.res.departmentValue.checkStandardValue = '查看参考值'
t.res.departmentValue.seeOrgTree = '查看组织架构'
t.res.departmentValue.departmentJobName = '部门/岗位名称'
t.res.departmentValue.standardNum = '参考人数'
t.res.departmentValue.exportTemple = '经销商组织架构参考值模板'
t.res.departmentValue.export = '导出模板'

// 课程
t.couse = {}
t.couse.couseq = 'Before class begins'
t.couse.jiez = 'Closing Registration(replace)'
t.couse.qiy = 'Enable waiting list'
t.couse.yxdealer = 'Allow in-store replacement'
t.couse.pxx = 'Training Needs Collection'
t.couse.xz = 'Restriction on Cancellation of Registration'
t.couse.xxc = 'Limit days of cancellation'
t.couse.rxc = 'Duplicate registration is allowed'
t.couse.dealer = 'Distributor'
t.couse.dealerwx = 'Unlimited'
t.couse.xdstandard = 'Limitation criteria'
t.couse.ynstudy = 'Whether to Restrict Learning'
t.couse.zpush = 'Intra-Station Msg Push'
t.couse.mgroup = 'Group-oriented'
t.couse.creatmgroup = 'Create Group'
t.couse.createques = '等同课程维护'
t.couse.allowjob = 'Allow part-time job registration'

t.couse.allname = 'Name'
t.couse.allstate = 'state'
t.couse.alltype = 'type'
t.couse.allcz = 'operation'

t.couse.courseprice = 'Price(￥)'
t.couse.rewardscore = 'Reward points'
t.couse.noshowpenalty = 'Absence Deduction(￥)'
t.couse.consumptionscore = 'Consumption Integral'
t.couse.coureschex = 'Cancellation of payment'
t.couse.couresadd = '+Adding withdrawal rules for payment'
t.couse.budgetline = 'Budget number'
t.couse.cousrq = 'Before the start date of the course'
t.couse.couresday = 'Day, fine'
t.couse.couresdele = 'Delete'

// 课程列表查询
t.couse.brand = 'brand'
t.couse.coursecatalogid = 'Classification of courses'
t.couse.courseteamcatalogid = 'Classification of curriculum teams'
t.couse.course = 'Course'
t.couse.coursename = 'Course Name'
t.couse.coursestatus = 'Course Status'
t.couse.coursekind = 'Course Types'
t.couse.coursekind1 = '课程类型'
t.couse.courselabel = 'Course label'
t.couse.collectiondemandflag = 'Training Needs Collection'
t.couse.limitvisiableflag = 'Whether to Restrict Learning'
t.couse.createuser = 'Creator'
t.couse.createtime = 'Create Time'
t.couse.endData1 = '结束时间'
t.couse.startdate1 = '开始时间'
// 调查问卷url
t.couse.investigationAddressurl = 'http://joylearning.bmw.bmw.com.cn:7000/'

// 子页面
t.couse.coursekinds = '学习对象类型'
t.couse.courseCoursekinds = '学习对象类型'
t.couse.courseNamecns = '课程中文名称'

// 课程列表
t.couse.no = 'No.'
t.couse.coursecode = 'Course Code'
t.couse.coursenamecn = 'Chinese Name of Course'
t.couse.coursenameen = 'English Name of Course'
t.couse.coursestatus = 'Course Status'
t.couse.count = 'Number of people in need'
t.couse.handle = 'operation'
t.couse.coursedays = 'Standard duration (days)'
t.couse.maxnumber = 'Maximum number'
t.couse.minnumber = 'Minimum number'
t.couse.undercarriage = 'Undershelf'
t.couse.active = '发布'
t.couse.keepon = 'keep on file'
t.couse.delete = 'Delete'
t.couse.courseExport = 'Course Export'
t.couse.edit = 'Edit'
t.couse.coursecodes = '课程名称'
t.couse.coursenamecn = 'Chinese Name of Course'
t.couse.courseCoursekind = 'Course Types'
t.couse.couseImporttemplate = '报名人数导入模板'

t.couse.groupName = '组群名称'
t.couse.groupRemark = '组群描述'
t.couse.createUserName = '创建人'
t.couse.limitCourseStartdate = '课程限制报名有效期'
t.couse.limitCourseEnddate = '      '
t.couse.startdate = '开始日期'
t.couse.enddate = '结束日期'
t.couse.conditiontile = '前提条件'
t.couse.conditionnotice = '注：选项与选项之间为“或”（OR）的关系；选项中子项与子项之间为“与”（AND）的关系'
t.couse.conditiondesc = '已报名：用户在报名本课程前必须已报名前提课，且在本课程开始日期N天之前必须完成该前提课程，否则会产生撤销扣款'
t.couse.conditionlimit = '限制报名人数'
t.couse.conditionlimitOption = '限制查看设置'
t.couse.offringclass = '排课'
t.couse.option = '选项'
t.couse.begincourse = '选项内的课程在课程开始'
t.couse.daysago = '天前完成'
t.couse.coursequres = '课程查询'
t.couse.csreplace = '截止报名(替换)'
t.couse.csend = '截止替换时间与截止报名日期一致'
t.couse.csaddnew = '添加新选项'
t.couse.cssignup = '人报名'
t.couse.csupload = '点击上传'
t.couse.cszupload = '自定义上传'
t.couse.csdealerno = '除上传经销商外，其他经销商不受限制'
t.couse.csgroupq = '面向组群查询'
t.couse.equestitle = '等同关系'
t.couse.equecombination = '组合'
t.couse.equespackage = '等同包'
t.couse.equescoursecode = '课程编号'
t.couse.equesname = '课程名称'
t.couse.equestype = '类型'
t.couse.equesstate = '状态'
t.couse.csgroututitle = '面向组群'

// 课程分类
t.catalog = {}
t.catalog.catalognamecn = 'Category name'
t.catalog.catalogstatus = 'Classification status'

// course 基本信息
t.course = {}
t.course.courseBrand = 'courseBrand'
t.course.courseclassify = 'Course classify'
t.course.courseTeamCatalogId = 'course Team Catalog Id'
t.course.maxNumber = 'maxNumber'
t.course.minNumber = 'minNumber'
t.course.courseNameCn = 'course Name Cn'
t.course.courseNameEn = 'course Name En'
t.course.courseIntroduction = 'course Introduction'
t.course.courseDays = 'course Days（day）'
t.course.projectCourseFlag = 'Project Course'
t.course.courseKind = 'Course Kind'
t.course.courseCode = 'Course Code'
t.course.covers = 'Cover'
t.course.banner = 'Banner'
t.course.agCodes = 'agCodes'
t.course.passMarkFlag = 'set PassLine'
t.course.passMarkScore = 'Pass score'
t.course.undercarriagemsg = 'In order to avoid the inconvenience caused by this operation to hybrid learning, please go to hybrid learning to confirm whether the course is used before handling.'
t.couse.appcatalog = 'APP课程层级'
t.course.edit = '编辑'

t.couse.exportMsg = '选中序号列前的勾选框，可导出当页数据；不勾选任何选项，可导出全部数据'
t.couse.premisetMsg = '前提条件/前置条件更改将同步到所有已发布/未发布排期，已结束排期不会发生变更'
t.couse.conditionlimitMsg = '限制更改将同步到所有已发布/未发布排期，已结束排期不会发生变更'

t.couse.noticetDealerMsg = 'For dealer administrator'
t.couse.noticetMsg = 'For trainees'

// course 公共
t.course.tag = '课程标签'
t.course.plsin = '请输入'
t.course.pls = '请'
t.course.select = '请选择'
t.course.query = '查询'
t.course.plsInputCodeorName = '课程代码/名称'

// 导航
t.course.csbase = '基本信息'
t.course.cscondition = '报名条件'
t.course.csprice = '价格相关'
t.course.csrpt = '报表相关'
t.course.csinvest = '调查问卷'
t.course.csability = '能力项设置'

// 页面保存
t.course.saveAndNext = '保存并下一步'
t.course.save = '保存'
t.course.cancel = '取消'
t.course.saveAndRelease = '保存并发布'
t.course.next = '下一步'
t.course.remove = '关闭'
t.course.return = '返回'

// 报表相关
t.course.countUtilizationFlag = '是否统计在课程使用率报表'
t.course.quickTestFlag = '是否是快测课程'
t.course.serioustraining = '是否统计在培训认证通过率报表'
t.couse.BBASplit = 'BBA Sharing Ratio'

t.couse.BBASplit = 'BBA Sharing Ratio'

// 调查问卷
t.course.investigationName = '调查问卷'
t.course.investigationAddress = '问卷地址'
t.course.center = '操作'
t.course.delete = '移除'
t.course.operation = '操作'
t.course.addInvestigationName = '+添加问卷'
t.course.addOK = '添加调查文件成功'

// 课程创建完成
t.course.courseReleaseOK = '课程发布成功！'
t.course.coursebtnJumpOffering = '创建排期 >>'
t.course.courseTrainer = '课程培训师关系维护 >>'
t.course.courseTeacher = '课程教室关系维护   >>'
t.course.courseVehicle = '课程车辆关系维护   >>'

t.course.deletewarn = '当前课程有未发布或已发布状态的排期，不可删除'
t.course.undercarriagewarn = '当前课程有未发布或已发布状态的排期，不可下架'
t.course.pleaseChooseData = '请选择数据'
t.course.ondb = '该课程已选择，请选择其他课程!'
t.couse.selectedCourse = '已选课程'

// 排期相关
t.offering = {}
t.offering.selectCourse = '选择课程'
t.offering.catalog = '课程分类'
t.offering.teamCatalogId = '团队课程分类'
t.offering.startdate = '开始时间'
t.offering.enddate = '结束时间'
t.offering.location = '所在场地'
t.offering.local = '场地'
t.offering.city = '所在城市'
t.offering.offeringNo = '排期编号'
t.offering.offeringRemark = '备注'
t.offering.offringname = '排期名称'
t.offering.tag = '课程标签'
t.offering.offringstatus = '排期状态'
t.offering.no = '序号'
t.offering.countuser = '报名人数'
t.offering.trainer = '培训师'
t.offering.creator = '创建人'
t.offering.releaseTime = '排期发布时间'
t.offering.view = '查看'
t.offering.edit = '编辑'
t.offering.listDelete = '删除'
t.offering.copy = '复制'
t.offering.cancel = '取消'
t.offering.cancelview = '查看取消'
t.offering.distribution = '分配'
t.offering.showplist = '人员名单'
t.offering.offeringExport = '排期导出'
t.offering.downloadtemplate = '排期模板下载'
t.offering.batchImport = '批量上传'
t.offering.report = '结果报告下载'
t.offering.Release = '发布'
t.offering.batchdeletion = '批量删除'
t.offering.trainerId = '培训师编号'
t.offering.trainerType = '培训师类型'
t.offering.trainerName = '培训师名称'
t.offering.starttime = '排期时间（开始）'
t.offering.endtime = '排期时间（结束）'
t.offering.actualdays = '实际培训时间（天）'
t.offering.operation = '操作'
t.offering.more = '操作'
t.offering.resourceing = '时间区间内有资源占用,请重新选择！'
t.offering.cancereasons = '请选择取消原因'
t.offering.cancereasonselect = '请选择原因'
t.offering.canceremarks = '备注'
t.offering.courseNameCncan = '面授课程'
t.offering.registNumbercan = '报名人数'
t.offering.waitingnumbercan = '已加入等候名单'
t.offering.startdatecan = '培训日期'
t.offering.siteNamecan = '地点'
t.offering.checkListNull = '请选择需要发布的排期'
t.offering.deletetips = '该排期已产生培训记录，不能删除'
t.offering.cancelreasonstips = '请选择取消原因'
t.offering.membershipPassword = '入会密码'
t.offering.recurringMeeting = '周期性会议'
t.offering.yes = '是 (默认选中状态)'
t.offering.noSec = '否'
t.offering.repeatFrequency = '重复频率'
t.offering.endRepetition = '结束重复'
t.offering.meetingSettings = '会议设置'
t.offering.openMeetingRegistration = '开启会议报名'
t.offering.openWaitingRoom = '开启等候室'
t.offering.conferenceEntry = '允许成员在主持人进会前进入会议'
t.offering.conferenceWatermark = '开启会议水印'
t.offering.joinMute = '成员入会时静音'
t.offering.turnOn = '开启 (默认选中状态)'
t.offering.closure = '关闭'
t.offering.turnOnSec = '开启'
t.offering.liveConference = '会议直播'
t.offering.setHost = '设置主持人'
// 排期导航
t.offering.offbase = '基本信息'
t.offering.offeringResources = '排期资源'
t.offering.offconditionAdd = '报名条件'
t.offering.offnoticeAdd = '报名通知'
t.offering.offpriceAdd = '价格相关'
t.offering.offinvestAdd = '调查问卷'
t.offering.offabilityAdd = '能力项设置'
// 排期调查问卷
t.offering.courseInvestigation = '面授课问卷'
t.offering.trainerInvestigation = '培训师问卷'
t.offering.select = '请选择'
t.offering.investigationId = '问卷编号'
t.offering.investigationName = '问卷名称'
t.offering.investigationDesc = '问卷描述'
t.offering.investigationAddress = '问卷地址'
t.offering.delete = '移除'
t.offering.investigationoperation = '操作'
t.offering.addCourseInvestigation = '添加面授课问卷'
t.offering.addTrainerInvestigation = '添加培训师问卷'
t.offering.addInvestigationName = '+添加问卷'

// 排期创建完成
t.offering.offeringReleaseOK = '排期发布成功！'
t.offering.offeringReleasecopy = '复制排期 >>'
t.offering.newOffering = '创建新的排期   >>'
// 通知方式
t.offering.signUpNoticeError = '通知方式不能为空'
t.offering.signUpNoticeConError = '模板内容不能为空'

t.offering.startErrorSave = '该排期状态已被修改，不允许编辑'

t.site = {}
t.site.selectSiteInfo = '场地'
t.site.name = '场地名称'
t.site.code = '场地编号'
t.site.classification = '场地分类'
t.site.status = '活动状态'
t.site.city = '所在城市'
t.site.serialNo = '序号'
t.site.type = '所属分类'
t.site.classification = '场地分类'
t.site.status = '场地状态'

// ************选择课程查询页面*********** */
t.offeringcd = {}
t.offeringcd.cousername = '课程名称'
t.offeringcd.cousercode = '课程代码'
t.offeringcd.cousernamecn = '课程中文名称'
t.offeringcd.cousernameen = '课程英文名称'
t.offeringcd.courseDays = '标准时长(天)'
t.offeringcd.intervalTime = '间隔时长(月)'
t.offeringcd.couserTeamcatalog = '课程团队分类'
t.offeringcd.cousercatalog = '课程分类'
t.offeringcd.cousertype = '课程类型'
t.offeringcd.couserstate = '课程状态'

// 审批报表
t.registe = {}
t.registe.username = '姓名'
t.registe.apprentice = '学员'
t.registe.companyBelong = '报名时所属公司'
t.registe.placeholderName = '请输入姓名'
t.registe.positionname = '职位'
t.registe.placeholderPositionName = '请输入职位'
t.registe.coursename = '课程名称'
t.registe.placeholderCourseName = '请输入课程名称'
t.registe.startdate = '开始时间'
t.registe.enddate = '结束时间'
t.registe.applyflag = '类型'
t.registe.no = 'NO.'
t.registe.userId = '用户ID'
t.registe.orgname = '经销商'
t.registe.coursename = '课程名称'
t.registe.offeringname = '排期名称'
t.registe.applydate = '申请时间'
t.registe.approvalstatus = '审批状态'
t.registe.approvalusername = '审批人'
t.registe.revokeUserName = '撤销操作人'
t.registe.agree = '同意'
t.registe.refuse = '拒绝'
t.registe.revokeremark = '撤销理由'
t.registe.approvalremark = '审批意见'
t.registe.change = '替换'
t.registe.revoke = '撤销'
t.registe.updataSign = '修改签到记录'
t.registe.updataSignMark = '修改签到记录及分数'
t.registe.lookSignMark = '查看签到记录及分数'
t.registe.lookSignMark2 = '查看签到记录'
t.registe.cancelPenalty = '免除'
t.registe.immune = '已免除'
t.registe.adduser = '添加用户'
t.registe.dealer = '经销商'
t.registe.pleaseChoose = '请选择'
t.registe.attendanceRecord = '签到记录'
t.registe.mark = '分数'
t.registe.queryWaitingList = '查看等待名单'
t.registe.displayRevokedList = '显示已撤销的用户'
t.registe.adduser = '添加用户'
t.registe.orgType = '经销商类型'
t.registe.dotType = '网点类型'
t.registe.selected = '已选对象'
t.registe.save = '保存'
t.registe.submission = '提交'
t.registe.cancel = '取消'
t.registe.sendEmail = '发送邮件'
t.registe.sendNotice = '发送通知'
t.registe.selectCheck = '请选择用户'
t.registe.select = '请选择'
t.registe.pleaseSelect = '请选择用户'
t.registe.input = '请填写....'
t.registe.no1 = '不收取撤销扣款'
t.registe.no2 = '不发送撤销通知'
t.registe.penaltyAmount = '扣款金额(元)'
t.registe.immuneAmount = '免除金额:'
t.registe.firstname = '姓'
t.registe.lastname = '名'
t.registe.confirmAssign = '确认为以下人员分配课程？'

// 分配管理
t.registe.changecourse = '选择课程'
t.registe.offeringcode = '排期编号'
t.registe.offeringname = '排期名称'
t.registe.offeringstatus = '排期状态'
t.registe.city = '所在城市'
t.registe.place1 = '所在场地'
t.registe.coursecode = '课程编号'
t.registe.coursename = '课程名称'
t.registe.trainer = '培训师'
t.registe.place2 = '场地'
t.registe.trainday = '实际培训时间'
t.registe.applycount = '报名人数'
t.registe.assign = '分配'
t.prompt.beyond = '剩余席位不足'

// 培训记录
t.registe.applyassigndate = '申请/分配时间'
t.registe.changeuser = '替换学员'
t.registe.select = '请从左侧选择....'
t.registe.showuser = '人员名单'

// 分配课程
t.assign = {}
t.assign.assigncourse = '分配课程'
t.assign.positionname = '主要职位'
t.assign.idcard = '身份证号'
t.assign.idNumber = '证件编号'
t.assign.parttimejobone = '兼职职位1'
t.assign.parttimejobtwo = '兼职职位2'
t.assign.partTimeJobThree = '兼职职位3'
t.assign.partTimeJobFour = '兼职职位4'
t.assign.partTimeJobFive = '兼职职位5'
t.assign.dealershiptype = '经销商类型'
t.assign.status = '状态'
t.assign.time = '时间'
t.assign.updateTime = '最后修改时间'
t.assign.userExport = '人员名单导出'
t.assign.timeRange = '创建时间(起始)'
t.assign.updateTimeRange = '最后修改时间(起始)'
t.assign.viewrevoke = '查看撤销'
t.assign.replaceuser = '替换用户'
t.assign.offeringdetail = '排期详细信息'
t.assign.detail = '详细信息'
t.assign.trainingdate = '培训日期'
t.assign.startEndDate = '开始时间-结束时间:'
t.assign.registeAbbreviationAn = '报名时所属公司:'
t.assign.site = '地点'
t.assign.Facetofacecourses = '面授课程:'
t.assign.course = '课程:'
t.assign.countuser = '报名人数:'
t.assign.trainingdate = '培训日期:'
t.assign.learner = '学员:'
t.assign.site = '地点:'
t.assign.coureschex = '撤销报名扣款:'
t.assign.revokeset = '撤销设置'
t.assign.immuneInfo = '免除信息'
t.assign.immune = '详细信息'
t.assign.revokeuser = '撤销学员:'
t.assign.revokereason = '请选择撤销原因*:'
t.assign.opinion = '意见:'
t.assign.save = '保存'

// 认证
t.cert = {}
t.cert.certname = 'cert Name'
t.cert.plsInput = 'please Input Cert No/Name'
t.cert.brand = 'brand'
t.cert.certType = 'cert Type'
t.cert.certStatus = 'cert Status'
t.cert.copyCert = 'copy Cert'
t.cert.certCode = 'cert Code'
t.cert.createUserName = 'create User'
t.cert.createDate = 'create Date'
t.cert.edit = 'edit'
t.cert.delete = 'delete'
t.cert.undercarriage = 'undercarriage'
t.cert.select = 'Please Choose'
t.cert.more = 'More'
t.cert.baseinfo = 'Basic Information'
t.cert.ralacourse = 'Relevant courses'
t.cert.certtemplaterule = 'Cert Template and Rules'
t.cert.recertrule = 'ReCert Rules'
t.cert.baseinfoset = 'Basic Information Setting'
t.cert.certRule = 'Cert Rules'
t.cert.certTemplate = 'Cert Template'
t.cert.certreRule = 'ReCert Rules Setting'
t.cert.selectTips = 'Please Select '
t.cert.inputTips = 'Please Input '
t.cert.certCode = 'cert Code'
t.cert.autobysystem = 'Automatic Calculated'
t.cert.certNameCn = 'Cert Chinese Name'
t.cert.certNameEn = 'Cert English Name'
t.cert.brand = 'brand'
t.cert.certLevel = 'Cert Level'
t.cert.courseTeamCatalog = 'Team Classification'
t.cert.cancel = 'Cancel'
t.cert.save = 'Save'
t.cert.savefornext = 'Save And Next'
t.cert.saveforrelease = 'Save And Release'
t.cert.cancelinfo = '离开本页将不保存当前正在编辑的数据，确定离开？'
t.cert.validPeriod = 'Valid Period Of Cert'
t.cert.recertFlag = 'Need To ReCert'
t.cert.recertFlagTips = '选择否时，延续认证规则将被删除'
t.cert.selectTemplate = 'Select Cert Template'
t.cert.ruleExplain = '注：选项与选项之间为"或"（OR）的关系；选项中子项与子项之间为"与"（AND）的关系'
t.cert.ruleOption = 'Option'
t.cert.coursename = 'Course Name'
t.cert.completeStatus = 'Training Status Require'
t.cert.coursekind = 'Learning Kind'
t.cert.addOption = 'Add New Option'
t.cert.selectcourse = 'Course Select'
t.cert.annualRecert = 'ReCert Annual'
t.cert.annualRecertExplain = '注：延续的时间和认证有效期需要匹配，每一年的延续规则单独设置'
t.cert.addCertDup = '相同认证等级和所选认证名称的认证已存在'
t.cert.pleaseSelectCert = 'Please Select Cert'
t.cert.copyFont = 'Copy From'
t.cert.ruleToFont = 'Rule To'
t.cert.ruleCopyNotice = '注：规则包含“关联相关课程”和“认证模板及规则”'
t.cert.confirm = 'Confirm'
t.cert.pleaseSelectYearFrom = 'Please Select YearFrom'
t.cert.pleaseSelectYearTo = 'Please Select YearTo'
t.cert.noCertFrom = '{yearFrom}年的认证规则不存在'
t.cert.hasCertTo = '{yearTo}年的认证规则已存在'
t.cert.underStatusCannotCopy = '该认证规则已下架不能复制'
t.cert.unreleasedStatusCannotCopy = '该认证规则未发布不能复制'
t.cert.excelCertInfo = '认证信息表'
t.cert.certYear = 'Cert Annual'
t.cert.addCertYear = 'Add Cert Annual'
t.cert.closingDatepre = '于'
t.cert.closingDate = 'Closing Date'
t.cert.courseRequired = '必须有一个选项选择了关联课程'
t.cert.optionCourseRequired = '没有添加关联相关课程'
t.cert.closingDateRequired = '截止日期不允许为空'
t.cert.stepSaveRequired = '您存在没有保存的步骤'
t.cert.pleaseInputcertName = 'Please Input CertName'
t.cert.certruleSaveRequired = '该认证获得年的认证规则信息未保存'
t.cert.recertruleRequired = '该认证获得年的认证规则信息不需要延续'
t.cert.pleaseSelectCertName = 'Please Select CertName'
t.cert.next = 'Next'
t.cert.close = 'Close'
t.cert.add = 'Add'
t.cert.completeStatusRequired = '有课程的培训状态要求未选择'
t.cert.selectedCourse = 'Selected Course'
t.cert.courseondb = '该课程已选择，请选择其他课程!'
t.cert.return = 'Back'
t.cert.templateName = 'Template Name'
t.cert.keyword = 'Please Input Keyword'
t.cert.templateNo = 'TemplateNo'
t.cert.preview = 'Preview'
t.cert.pleaseSelectTemplate = 'Please Select Template'
t.cert.message = 'Message'
t.cert.coursekinds = 'Coursekinds'
t.cert.appcatalog = 'App Catalog'
t.cert.courseStatus = 'Course Status'
t.cert.courseNameEn = 'Course Name En'
t.cert.selectcourse = 'Course Select'
t.cert.certTeamCatalog = 'Cert Team Catalog'
t.cert.courseTeamCatalog2 = 'Course Team Catalog'
t.cert.courseNameCnLen = '认证中文名称字节长度不能超过7'
t.cert.noCertData = '该认证已删除'
t.cert.certStatusisDown = '该认证已下架，不允许编辑'
t.cert.exportMsg = '选中序号列前的勾选框，可导出当页数据；不勾选任何选项，可导出全部数据'
t.cert.inputCourse = '请输入课程代码/中英文'
t.cert.saveEditData = '是否确认保存当前正在编辑的数据?'
t.cert.rerulecourseRequired = '延续认证关联相关课程不能为空'
t.cert.reoptionCourseRequired = '没有添加延续认证关联相关课程'
t.cert.saveAnnualRecertDataPre = '是否确认保存'
t.cert.saveAnnualRecertDataSuf = '年编辑的延续认证规则数据?'

t.offering.resource = {}
t.offering.resource.selectSite = '选择场地'
t.offering.resource.delete = '删除'
t.offering.resource.cleanConfirmMsg = '修改场地将会清空除培训师外的全部资源，确定清空?'

t.offering.resourceIsNotice1 = '若更改排期时间和场地，请点击不发送。'
t.offering.resourceIsNotice2 = '若仅更改排期时间，不更改场地,请点击发送。'



t.offering.resource.trainer = '设置培训师'
t.offering.resource.trainerno = '序号'
t.offering.resource.trainerId = '用户ID'
t.offering.resource.trainerType = '培训师类型'
t.offering.resource.trainerName = '姓名'
t.offering.resource.trainerstarttime = '排期时间（开始）'
t.offering.resource.trainerendtime = '排期时间（结束）'
t.offering.resource.traineractualdays = '实际培训时间（天）'
t.offering.resource.traineroperation = '操作'
t.offering.resource.trainerConfirmMsg = '教师资源将被清空，确定清空?'
t.offering.resource.trainerDeleteConfirmMsg = '教师资源将被删除，确定删除?'
t.offering.resource.trainerNullMsg = '无教师资源信息，无需删除！'
t.offering.resource.traineractualdaysWarn = ':教师实际培训时间格式不正确！'
t.offering.resource.room = '设置教室'
t.offering.resource.roomno = '序号'
t.offering.resource.roomId = '教室编号'
t.offering.resource.roomType = '教室类型'
t.offering.resource.roomName = '教室名称'
t.offering.resource.roomCnAbbr = '教室简称'
t.offering.resource.roomstarttime = '使用时间（开始）'
t.offering.resource.roomendtime = '使用时间（结束）'
t.offering.resource.roomactualdays = '实际培训时间（天）'
t.offering.resource.roomoperation = '操作'
t.offering.resource.roomConfirmMsg = '教室资源将被清空，确定清空?'
t.offering.resource.roomDeleteConfirmMsg = '教室资源将被删除，确定删除?'
t.offering.resource.roomNullMsg = '无教室资源信息，无需删除！'
t.offering.resource.roomactualdaysWarn = ':教室实际培训时间格式不正确！'
t.offering.resource.vehicle = '设置车辆'
t.offering.resource.vehicleid = '序号'
t.offering.resource.vehicleNo = '车架号'
t.offering.resource.vehicleType = '车型分类'
t.offering.resource.vehicleName = '车辆名称'
t.offering.resource.vehicleBrand = '品牌'
t.offering.resource.vehiclestarttime = '使用时间（开始）'
t.offering.resource.vehicleendtime = '使用时间（结束）'
t.offering.resource.vehicleactualdays = '实际培训时间（天）'
t.offering.resource.vehicleoperation = '操作'
t.offering.resource.vehicleConfirmMsg = '车辆资源将被清空，确定清空?'
t.offering.resource.vehicleDeleteConfirmMsg = '车辆资源将被删除，确定删除?'
t.offering.resource.vehicleNullMsg = '无车辆资源信息，无需删除！'
t.offering.resource.vehicleactualdaysWarn = ':车辆实际培训时间格式不正确！'
t.offering.resource.material = '设置资产耗材'
t.offering.resource.materialno = '序号'
t.offering.resource.materialRequisitionsId = '领用单号'
t.offering.resource.materialType = '培训师类型'
t.offering.resource.materialName = '培训师名称'
t.offering.resource.materialstarttime = '使用时间（开始）'
t.offering.resource.materialendtime = '使用时间（结束）'
t.offering.resource.materialactualdays = '实际培训时间（天）'
t.offering.resource.materialoperation = '操作'
t.offering.resource.materialConfirmMsg = '资产耗材资源将被清空，确定清空?'
t.offering.resource.materialDeleteConfirmMsg = '资产耗材资源将被删除，确定删除?'
t.offering.resource.materialNullMsg = '无资产耗材资源信息，无需删除！'
t.offering.resource.materialactualdaysWarn = ':资产耗材实际培训时间格式不正确！'
t.offering.resource.tencentConferenceRoom = '腾讯会议室'
t.offering.resource.settingUpTencentMeetings = '设置腾讯会议'
t.offering.resource.conferenceTheme = '会议主题'

//CourseQuestion
t.course.coursequestion = {}
t.course.coursequestion.courseName = 'Course Name'
t.course.coursequestion.courseTrainer = 'Course development trainer'
t.course.coursequestion.createUser = 'Created by'
t.course.coursequestion.brand = 'brand'
t.course.coursequestion.team = 'Business team'
t.course.coursequestion.status = 'state'
t.course.coursequestion.courseQaId = 'Question Id'
t.course.coursequestion.courseCreatBy = 'Created by'
t.course.coursequestion.replyNum = 'Number of replies'
t.course.coursequestion.qaDate = 'Question time'
t.course.coursequestion.content = 'Question content'
t.course.coursequestion.headImg = 'picture'
t.course.coursequestion.operation = 'operation'
t.course.coursequestion.imageShow = 'see'
t.course.coursequestion.reply = 'reply'
t.course.coursequestion.shield = 'shield'
t.course.coursequestion.detail = 'detailed'
t.course.coursequestion.dialogReplyTitle = 'reply'
t.course.coursequestion.dialogReplycourseCreatBy = 'Course Creator'
t.course.coursequestion.dialogReplyId = 'Reply ID'
t.course.coursequestion.dialogReplyUser = 'Respondent'
t.course.coursequestion.dialogReplyDate = 'Reply time'
t.course.coursequestion.dialogReplyContent = 'Reply content'
t.course.coursequestion.dialogContinueReply = 'Continue reply'
t.course.coursequestion.img = 'picture'
t.course.coursequestion.dialogReply = 'reply'
t.course.coursequestion.dialogShield = 'shield'
t.course.coursequestion.dialogShielded = 'Shielded'
t.course.coursequestion.deletePrompt = 'Delete prompt'
t.course.coursequestion.allShieldPrompt = 'Are you sure you want to block all replies to this question?'
t.course.coursequestion.shieldPrompt = 'Are you sure you want to block this course?'
t.course.coursequestion.shieldSuccess = 'Shielding succeeded!'
t.course.coursequestion.replySuccess = 'Reply succeeded!'
t.course.coursequestion.replyPrompt = 'Please enter the reply content'


//微课评价
t.course.coursecomment = {}
t.course.coursecomment.courseCode = 'Course number'
t.course.coursecomment.courseName = 'Course Name'
t.course.coursecomment.brand = 'brand'
t.course.coursecomment.team = 'Business team'
t.course.coursecomment.trainer = 'Course development trainer'
t.course.coursecomment.creatRealName = 'Created by'
t.course.coursecomment.commentCount = 'Evaluation quantity'
t.course.coursecomment.commentTotalCount = 'Total number of evaluations'
t.course.coursecomment.avgScore = 'avgScore'
t.course.coursecomment.view = 'view'
t.course.coursecomment.operation = 'operation'
t.course.coursecomment.back = 'back'
t.course.coursecomment.export = 'export'
t.course.coursecomment.cancel = 'cancel'
t.course.coursecomment.confirm = 'confirm'
t.course.coursecomment.userName = 'userName'
t.course.coursecomment.userNamePlaceholder = 'Please enter the user name'
t.course.coursecomment.companyName = 'companyName'
t.course.coursecomment.companyNamePlaceholder = 'Please enter the dealer name'
t.course.coursecomment.practicalScore = 'practicability'
t.course.coursecomment.interestScore = 'interest'
t.course.coursecomment.informationScore = 'information content'
t.course.coursecomment.content = 'Evaluation content'
t.course.coursecomment.status = 'status'
t.course.coursecomment.contentTime = 'Evaluation time'
t.course.coursecomment.contentTimePlaceholderStart = 'Start date'
t.course.coursecomment.contentTimePlaceholderEnd = 'End date'
t.course.coursecomment.reply = 'reply'
t.course.coursecomment.shield = 'shield'
t.course.coursecomment.dialogUserName = 'Student account number'
t.course.coursecomment.dialogRealName = 'Student Name'
t.course.coursecomment.dialogPracticalScore = 'practicability'
t.course.coursecomment.dialogInterestScore = 'interest'
t.course.coursecomment.dialogInformationScore = 'information content'
t.course.coursecomment.dialogcontent = 'Evaluation content'
t.course.coursecomment.dialogreply = 'Reply evaluation'
t.course.coursecomment.dialogReplyTitle = 'Reply evaluation'
t.course.coursecomment.replyPrompt = 'Please enter the reply content'
t.course.coursecomment.replySuccess = 'Reply succeeded!'
t.course.coursecomment.replyFail = 'Reply failed!'
t.course.coursecomment.shieldConfirmPrompt = 'Shield prompt'
t.course.coursecomment.shieldPrompt ='Are you sure you want to block this evaluation information?'
t.course.coursecomment.shieldSuccess = 'Shielding succeeded!'
t.course.coursecomment.shieldFail = 'Shielding failed!'
t.course.coursecomment.viewCourseCode = 'Course number:'
t.course.coursecomment.viewCourseName = 'Course Name:'
t.course.coursecomment.viewAvgScore = 'average:'
t.course.coursecomment.viewCommentTotalCount = 'Total number of evaluations:'
t.course.coursecomment.exportConfirmPrompt = 'Export prompt'


export default t

